import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

import { HuonekorttiResponse } from "@/api/models/huonekortti-response"
import { useHuonekorttiTable } from "./huonekorttiTable"
import huonekorttiTableStore from "./huonekorttiTableStore"
import { computed, onUnmounted, PropType } from "vue"
import ComStatusTag from "@/components/common/ComStatusTag.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ComHuonekorttiTable',
  props: {
    huonekortit: {
        type: Object as PropType<HuonekorttiResponse[]> | undefined,
    },
    selection: {
        type: Boolean,
        default: false,
    },
},
  setup(__props) {

const props = __props
const { formatTilat } = useHuonekorttiTable()
const setSelected = huonekorttiTableStore.methods.setSelected
const selectable = computed(() => props.selection)

const handleSelectionChange = (val: HuonekorttiResponse[]) => {
    setSelected(val.map((item) => item.id))
}

// Tyhjennä valinta storesta kun taulukko poistuu näkymästä,
// jottei vanhentunut valinta jää muille raporttinäkymille
onUnmounted(() => setSelected([]))

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(_component_el_table, {
    data: __props.huonekortit,
    onSelectionChange: handleSelectionChange,
    "row-key": "id"
  }, {
    default: _withCtx(() => [
      (selectable.value)
        ? (_openBlock(), _createBlock(_component_el_table_column, {
            key: 0,
            type: "selection",
            width: "55",
            "reserve-selection": ""
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_table_column, {
        label: "Tilanimike",
        prop: "tilanimike.nimi"
      }),
      _createVNode(_component_el_table_column, {
        label: "Täsmennys",
        prop: "toiminta",
        "show-overflow-tooltip": ""
      }),
      _createVNode(_component_el_table_column, {
        label: "Status",
        prop: "status"
      }, {
        default: _withCtx((scope) => [
          _createVNode(ComStatusTag, {
            status: scope.row.status
          }, null, 8, ["status"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_table_column, {
        label: "Vastuuyksikkö",
        prop: "vastuuyksikko.nimi"
      }),
      _createVNode(_component_el_table_column, {
        label: "Tilat",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx((scope) => [
          _createTextVNode(_toDisplayString(_unref(formatTilat)(scope.row.tilat)), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})